import createReduxConstants from 'app/helpers/redux/createReduxConstants';

// TODO: replace with CATALOG_BIB_IMAGE_INFO_TYPE in displayBib constants
const BIB_IMAGE_INFO_TYPE = {
  LOCAL: 'LOCAL',
  NONLOCAL: 'NONLOCAL'
};

const ITEMS_PER_PAGE_LIMIT = 20;

// TODO: replace with CATALOG_BIB_TITLE_TYPE in displayBib constants
const BIB_TITLE_TYPE = {
  MANIFESTATION: 'MANIFESTATION',
  VARIANT: 'VARIANT'
};

const LIST_ITEM_TYPE = {
  BIB: 'bib',
  WEB: 'url'
};

// In the localizations en-US file
// there are a number of types that are no longer supported
// but may be assigned to older lists.
const LIST_TYPE = {
  GENERAL_RECOMMENDATIONS: 'other',
  GENRE_GUIDE: 'genre_guide',
  HEALTHCARE_GUIDE: 'health_guide',
  IF_YOU_LIKED: 'read_a_like',
  'K-12_STUDY_GUIDE': 'k12_study_guide',
  PERSONAL_RECOMMENDATION: 'personal_recommendation',
  STAFF_PICKS: 'staff_picks',
  TOP_PICKS: 'top_10',
  TOPIC_GUIDE: 'topic_guide'
};

const LIST_VISIBILITY_TYPE = {
  EVERYWHERE: 'visible_everywhere',
  LINK: 'visible_by_link'
};

const REDUX_CONSTANTS = createReduxConstants('LIST', {
  GET_BIB_ITEM_AVAILABILITIES_REQUEST: null,
  GET_BIB_ITEM_AVAILABILITIES_SUCCESS: null,
  GET_BIB_ITEM_AVAILABILITIES_FAILURE: null,

  GET_LIST_BY_ID_REQUEST: null,
  GET_LIST_BY_ID_SUCCESS: null,
  GET_LIST_BY_ID_FAILURE: null,

  GET_LIST_ITEMS_REQUEST: null,
  GET_LIST_ITEMS_SUCCESS: null,
  GET_LIST_ITEMS_FAILURE: null
});

export {
  BIB_IMAGE_INFO_TYPE,
  BIB_TITLE_TYPE,
  ITEMS_PER_PAGE_LIMIT,
  LIST_ITEM_TYPE,
  LIST_TYPE,
  LIST_VISIBILITY_TYPE,
  REDUX_CONSTANTS
};
